import { FC } from 'react';

import IconFile from '@/assets/svg/icon-img.svg?react';
import IconSwap from '@/assets/svg/icon-swap.svg?react';

import { Button } from '@/components/ui/button';

interface FileSelectionHeaderProps {
  onLeftSelect: () => void;
  onRightSelect: () => void;
  onSwap: () => void;
  leftFilename?: string;
  rightFilename?: string;
}

const FileSelectionHeader: FC<FileSelectionHeaderProps> = ({
  onLeftSelect,
  onRightSelect,
  onSwap,
  leftFilename,
  rightFilename,
}) => (
  <div className="mb-4 flex flex-col items-center justify-between gap-4 sm:flex-row">
    <Button onClick={onLeftSelect} variant="outline" className="h-10">
      Обрати файл
    </Button>
    <div className="relative flex w-full items-center justify-center gap-4">
      <div className="absolute left-0 flex w-[46%] items-center justify-end gap-4 text-sm">
        <IconFile className="h-4 min-w-4 fill-dark-red" />
        <span className="truncate">{leftFilename || 'Оберіть файл'}</span>
      </div>
      <button
        className="rounded-md p-2 hover:bg-gray-100 disabled:hover:bg-transparent"
        onClick={onSwap}
      >
        <IconSwap className="h-6 w-6 fill-primary" />
      </button>
      <div className="absolute right-0 flex w-[46%] items-center gap-4 text-sm">
        <IconFile className="h-4 min-w-4 fill-dark-red" />
        <span className="truncate">{rightFilename || 'Оберіть файл'}</span>
      </div>
    </div>
    <Button onClick={onRightSelect} variant="outline" className="h-10">
      Обрати файл
    </Button>
  </div>
);

export default FileSelectionHeader;
